import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2B19EECF-71BF-41F3-B62A-468607BA0B47
 * name format-list-checks
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-checks.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListChecksIcon = createSvgIcon(<><path d="M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z" /></>, 'FormatListChecksIcon');
export default FormatListChecksIcon